import { Notification as INotification } from '@copera/notification';
import { useNavigate } from 'react-router';
import { useNotificationContent } from './useNotificationContent';

export const useBrowserNotification = () => {
  const navigate = useNavigate();
  const notificationAvailable = 'Notification' in window;

  const { getNotificationContent } = useNotificationContent();

  const hasPermission = () => {
    if (!notificationAvailable) {
      return false;
    }

    return Notification.permission === 'granted';
  };

  const requestPermission = async () => {
    try {
      await Notification.requestPermission();
      return true;
    } catch (error) {
      return false;
    }
  };

  const notify = (notification: INotification) => {
    if (!hasPermission || !notificationAvailable) {
      return;
    }

    const { description, title, navigateTo } =
      getNotificationContent(notification);

    try {
      const n = new Notification(title, {
        body: description,
        tag: notification.type,
        icon: `${window?.location?.origin}/logo/copera-logo.png`,
      });

      n.onclick = () => {
        if (navigateTo) {
          navigate(navigateTo);
        }
        n.close();
      };
    } catch (error) {
      // ops, something went wrong
    }
  };

  return {
    hasPermission,
    requestPermission,
    notificationAvailable,
    notify,
  };
};
